// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-wrapper {
    background-color: #F7F7F7;
    min-height: 100vh;
}

.report-table {
    margin-top: 30px;
    border: 1px solid #E8E8E8
}

.report-table .thead {
    background-color: #FAFAFA;
    border-radius: 4px 0px;
}

.report-table {
    background-color: #FCFCFC;
}

.report-table .badge.bg-primary {
    background-color: #00863E !important;
    color: #fff;
}

.report-table .badge.bg-secondary {
    background-color: #007BB6 !important;
    color: #fff;
}

.report-table tr {
    background-color: #FAFAFA;
    border-bottom: 1px solid #E8E8E8
}

.report-table .thead th {
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    background-color: transparent;
    background-color: #FAFAFA;
}

.report-table.table>:not(caption)>*>* {
    background-color: transparent;
    font-family: Open Sans;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0em;
    text-align: left;
    color: #4C4C4C;
}


.report-table td {
    font-family: Open Sans;
    font-size: 22px!important;
    font-weight: 400;
    line-height: 30px!important;
    letter-spacing: 0em;
    text-align: left;
    color: #000!important;
    padding-top: 15px;
    padding-bottom: 15px;
}


.report-wrapper .form-check-input {
    border: 1px solid #E0E0E0;
    background-color: #EFEFEF;
    width: 23px;
    height: 23px;
    border-radius: 5px;
}

.report-wrapper .form-check-input:checked {
    background-color: #84FFBE52;
    border-color: #fff;

}

.report-table tbody td{
    padding-top: 20px;
    padding-bottom: 20px;
}

.chart-visibility {
    top: 0;
    position: absolute;
    z-index: -1;
    opacity: 0;
    overflow: hidden;
    left: 0;
}
`, "",{"version":3,"sources":["webpack://./src/screens/dashboard/report.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;AACxB;;;AAGA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;;AAEtB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,MAAM;IACN,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,OAAO;AACX","sourcesContent":[".report-wrapper {\n    background-color: #F7F7F7;\n    min-height: 100vh;\n}\n\n.report-table {\n    margin-top: 30px;\n    border: 1px solid #E8E8E8\n}\n\n.report-table .thead {\n    background-color: #FAFAFA;\n    border-radius: 4px 0px;\n}\n\n.report-table {\n    background-color: #FCFCFC;\n}\n\n.report-table .badge.bg-primary {\n    background-color: #00863E !important;\n    color: #fff;\n}\n\n.report-table .badge.bg-secondary {\n    background-color: #007BB6 !important;\n    color: #fff;\n}\n\n.report-table tr {\n    background-color: #FAFAFA;\n    border-bottom: 1px solid #E8E8E8\n}\n\n.report-table .thead th {\n    font-family: Open Sans;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 16px;\n    letter-spacing: 0em;\n    text-align: left;\n    background-color: transparent;\n    background-color: #FAFAFA;\n}\n\n.report-table.table>:not(caption)>*>* {\n    background-color: transparent;\n    font-family: Open Sans;\n    font-size: 20px;\n    line-height: 30px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #4C4C4C;\n}\n\n\n.report-table td {\n    font-family: Open Sans;\n    font-size: 22px!important;\n    font-weight: 400;\n    line-height: 30px!important;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #000!important;\n    padding-top: 15px;\n    padding-bottom: 15px;\n}\n\n\n.report-wrapper .form-check-input {\n    border: 1px solid #E0E0E0;\n    background-color: #EFEFEF;\n    width: 23px;\n    height: 23px;\n    border-radius: 5px;\n}\n\n.report-wrapper .form-check-input:checked {\n    background-color: #84FFBE52;\n    border-color: #fff;\n\n}\n\n.report-table tbody td{\n    padding-top: 20px;\n    padding-bottom: 20px;\n}\n\n.chart-visibility {\n    top: 0;\n    position: absolute;\n    z-index: -1;\n    opacity: 0;\n    overflow: hidden;\n    left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
